import React, { useState } from "react";
import { Button, Modal } from "@opendate-app/setlist";
import TemplateHTMLPreview from "../../BeefreeTemplates/TemplateHTMLPreview";

const styles = {
  card: {
    width: 208,
    border: "1px solid var(--sl-border-secondary)",
    borderRadius: 12,
    background: "var(--sl-bg-primary)",
    boxShadow: "var(--sl-shadow-xs)",
    overflow: "hidden",
  },
  thumbnail: {
    position: "relative",
    height: 168,
    margin: 16,
    border: "1px solid var(--sl-border-secondary)",
    background: "#FFFFFF",
    overflow: "hidden",
  },
  thumbnailFrame: {
    width: 560,
    height: 560,
    overflow: "hidden",
    border: "none",
    transform: "scale(0.315)",
    transformOrigin: "0 0",
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
  },
  details: {
    borderTop: "1px solid var(--sl-border-secondary)",
    padding: 16,
  },
  name: {
    color: "var(--sl-text-primary)",
    fontWeight: 600,
    lineHeight: "20px",
    minHeight: 20,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 12,
  },
  preview: {
    height: "min(600px, 70vh)",
    background: "#FFFFFF",
  },
  previewFrame: {
    width: "100%",
    height: "100%",
    overflow: "hidden",
    border: "none",
  },
};

export default ({
  template,
  onSelect,
}) => {
  const [previewing, setPreviewing] = useState(false);
  const name = template.templatable?.name;

  return (
    <div style={styles.card}>
      <div style={styles.thumbnail}>
        <TemplateHTMLPreview htmlContent={template.template_html} style={styles.thumbnailFrame} />
      </div>
      <div style={styles.details}>
        <div style={styles.name} title={name}>{name}</div>
        <div style={styles.actions}>
          <Button variant="primary" size="sm" aria-label={name ? `Select ${name}` : undefined} onClick={onSelect}>
            Select
          </Button>
          <Button variant="link-color" size="sm" aria-label={name ? `Preview ${name}` : undefined} onClick={() => setPreviewing(true)}>
            Preview
          </Button>
        </div>
      </div>
      <Modal
        open={previewing}
        onClose={() => setPreviewing(false)}
        width={840}
        title={name}
      >
        <div style={styles.preview}>
          <TemplateHTMLPreview htmlContent={template.template_html} style={styles.previewFrame} />
        </div>
      </Modal>
    </div>
  );
};
